/**
 * scrollObj
 * @desc Controls scrolling to methods
 * 
 */
const scrollObj = {

  /**
   * toEle
   * @desc Scrolls to an element
   * @param {Object} element 
   * @param {number} timing 
   * @param {number} offset 
   * @param {string} easing 
   * @param {function} callback 
   */
  toEle: function( element, timing = 500, offset = 0, easing = 'linear' , callback = () => { return; } ) {
    var obj = $(element);

    if(obj.length){
      var i = obj.offset().top + offset;

      $("html").stop().animate({ scrollTop: i }, timing, easing, function(){
        callback();
      });

      return false;
    }
  },

  /**
   * toId
   * @desc Scrolls to an ID (# in url)
   * @param {Object} obj 
   * @param {Object} e 
   */
  toId: function(obj, e) {
    var href = "";

    if   (obj) href = obj.attr('href');
    else href       = window.location.href;

    if ( href != null && href.indexOf('#') != -1 ){
      var anchor = href.slice(href.indexOf('#')+1);
      var ele    = $('[data-scroll-anchor="' + anchor + '"]');

      if( ele.length != 0 ){
        if (e) e.preventDefault();
        this.toEle( ele, null, $('header').innerHeight()*-1 );
      }
    }
  },

};


(function (window, $) {
  'use strict';
  $(window).on('load', function(){
    scrollObj.toId();     
  });

})(window, jQuery);